import { useEffect, useState } from 'react'; // 추가
import { SimpleGrid, Card, Image, Text, Badge, Group, Button, Title, Center, Loader } from '@mantine/core';
import { useNavigate } from 'react-router-dom';
import { mockSongs } from '../data/mockData';
import { Layout } from '../components/Layout';
import { Mic } from 'lucide-react';
import styles from './MainPage.module.css';

export default function MainPage() {
    const navigate = useNavigate();

    const [songs, setSongs] = useState([]); // 데이터를 담을 상태
    const [loading, setLoading] = useState(true); // 로딩 상태

    useEffect(() => {
        // 서버에서 노래 데이터 가져오기
        const fetchSongs = async () => {
            try {
                const apiUrl = process.env.REACT_APP_API_URL || '';
                const response = await fetch(`${apiUrl}/api/songs`);
                const data = await response.json();
                setSongs(data);
            } catch (error) {
                console.error('Error fetching songs:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchSongs();
    }, []);

    if (loading) {
        return (
            <Layout>
                <Center style={{ height: '50vh' }}>
                    <Loader size="xl" />
                </Center>
            </Layout>
        );
    }

    return (
        <Layout>
            <Group justify="space-between" mb="xl">
                <Title order={2} c="dimmed">Select a Challenge</Title>
                <Button variant="outline" color="cyan" size="md" onClick={() => navigate('/create')}>
                    + Create New Song
                </Button>
            </Group>

            <SimpleGrid cols={{ base: 1, sm: 2, md: 3 }} spacing="lg">
                {songs.map((song) => (
                    <Card
                        key={song.id}
                        shadow="sm"
                        padding="lg"
                        radius="md"
                        withBorder
                        className={styles.songCard}
                        onClick={() => navigate(`/challenge/${song.id}`)}
                    >
                        <Card.Section>
                            <Image
                                className={styles.songCardImage}
                                src={song.cover_url} // DB 컬럼명에 맞춤
                                height={160}
                                alt={song.title}
                            />
                        </Card.Section>

                        <Group justify="space-between" mt="md" mb="xs">
                            <Text fw={500} size="lg">{song.title}</Text>
                            <Badge color="pink" variant="light">
                                {song.difficulty} {/* DB 컬럼 직접 참조 */}
                            </Badge>
                        </Group>

                        <Text size="sm" c="dimmed" mb="md">
                            {song.artist}
                        </Text>

                        <Text size="sm" c="dimmed" lineClamp={2} mb="md" className={styles.lyricsPreview}>
                            "{song.full_lyrics}" {/* DB 컬럼 직접 참조 */}
                        </Text>

                        <Button
                            fullWidth
                            mt="md"
                            radius="md"
                            variant="gradient"
                            gradient={{ from: 'violet', to: 'cyan', deg: 90 }}
                            leftSection={<Mic size={16} />}
                        >
                            Start Challenge
                        </Button>
                    </Card>
                ))}
            </SimpleGrid>
        </Layout>
    );
}